import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PlagiarismCheckerService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {
  }

  checkCoursePlagiarismByWinston(id) {
    return this.http.get(`${environment.apiUrl}/PlagiarismChecker/CheckCoursePlagiarismByWinston?courseId=${id}`, {
      reportProgress: true,
      observe: 'events'
    });
  }
  checkAnswersPlagiarism(data) {
    return this.http.post(`${environment.apiUrl}/PlagiarismChecker/CheckAnswersPlagiarism`, data, {
      reportProgress: true,
      observe: 'events'
    });
  }
  getCoursePlagiarismResult(id) {
    return this.http.get(`${environment.apiUrl}/PlagiarismChecker/GetCoursePlagiarismResult?courseId=${id}`);
  }

}
